"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Apache = void 0;
var Apache;
(function (Apache) {
    Apache[Apache["Continue"] = 100] = "Continue";
    Apache[Apache["SwitchingProtocols"] = 101] = "SwitchingProtocols";
    Apache[Apache["Processing"] = 102] = "Processing";
    Apache[Apache["Ok"] = 200] = "Ok";
    Apache[Apache["Created"] = 201] = "Created";
    Apache[Apache["Accepted"] = 202] = "Accepted";
    Apache[Apache["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
    Apache[Apache["NoContent"] = 204] = "NoContent";
    Apache[Apache["ResetContent"] = 205] = "ResetContent";
    Apache[Apache["PartialContent"] = 206] = "PartialContent";
    Apache[Apache["MultiStatus"] = 207] = "MultiStatus";
    Apache[Apache["AlreadyReported"] = 208] = "AlreadyReported";
    Apache[Apache["ImUsed"] = 226] = "ImUsed";
    Apache[Apache["MultipleChoices"] = 300] = "MultipleChoices";
    Apache[Apache["MovedPermanently"] = 301] = "MovedPermanently";
    Apache[Apache["Found"] = 302] = "Found";
    Apache[Apache["SeeOther"] = 303] = "SeeOther";
    Apache[Apache["NotModified"] = 304] = "NotModified";
    Apache[Apache["UseProxy"] = 305] = "UseProxy";
    Apache[Apache["TemporaryRedirect"] = 307] = "TemporaryRedirect";
    Apache[Apache["PermanentRedirect"] = 308] = "PermanentRedirect";
    Apache[Apache["BadRequest"] = 400] = "BadRequest";
    Apache[Apache["Unauthorized"] = 401] = "Unauthorized";
    Apache[Apache["PaymentRequired"] = 402] = "PaymentRequired";
    Apache[Apache["Forbidden"] = 403] = "Forbidden";
    Apache[Apache["NotFound"] = 404] = "NotFound";
    Apache[Apache["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    Apache[Apache["NotAcceptable"] = 406] = "NotAcceptable";
    Apache[Apache["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
    Apache[Apache["RequestTimeout"] = 408] = "RequestTimeout";
    Apache[Apache["Conflict"] = 409] = "Conflict";
    Apache[Apache["Gone"] = 410] = "Gone";
    Apache[Apache["LengthRequired"] = 411] = "LengthRequired";
    Apache[Apache["PreconditionFailed"] = 412] = "PreconditionFailed";
    Apache[Apache["RequestEntityTooLarge"] = 413] = "RequestEntityTooLarge";
    Apache[Apache["RequestUriTooLong"] = 414] = "RequestUriTooLong";
    Apache[Apache["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    Apache[Apache["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
    Apache[Apache["ExpectationFailed"] = 417] = "ExpectationFailed";
    Apache[Apache["ImATeapot"] = 418] = "ImATeapot";
    Apache[Apache["MisdirectedRequest"] = 421] = "MisdirectedRequest";
    Apache[Apache["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    Apache[Apache["Locked"] = 423] = "Locked";
    Apache[Apache["FailedDependency"] = 424] = "FailedDependency";
    Apache[Apache["UpgradeRequired"] = 426] = "UpgradeRequired";
    Apache[Apache["PreconditionRequired"] = 428] = "PreconditionRequired";
    Apache[Apache["TooManyRequests"] = 429] = "TooManyRequests";
    Apache[Apache["RequestHeaderFieldsTooLarge"] = 431] = "RequestHeaderFieldsTooLarge";
    Apache[Apache["UnavailableForLegalReasons"] = 451] = "UnavailableForLegalReasons";
    Apache[Apache["InternalServerError"] = 500] = "InternalServerError";
    Apache[Apache["NotImplemented"] = 501] = "NotImplemented";
    Apache[Apache["BadGateway"] = 502] = "BadGateway";
    Apache[Apache["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    Apache[Apache["GatewayTimeout"] = 504] = "GatewayTimeout";
    Apache[Apache["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
    Apache[Apache["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
    Apache[Apache["InsufficientStorage"] = 507] = "InsufficientStorage";
    Apache[Apache["LoopDetected"] = 508] = "LoopDetected";
    Apache[Apache["NotExtended"] = 510] = "NotExtended";
    Apache[Apache["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
})(Apache = exports.Apache || (exports.Apache = {}));
//# sourceMappingURL=apache.js.map